export default {
    listMailSent: state => state.listMailSent,
    getSearchFilter: state => state.searchFilter,
    mode: state => state.mode,
}